<template>
  <div class="left">
    <div class="left-item">
      <div class="item-title">发布时间</div>
      <div class="item-content" :class="indexT === index?'searchactive':''" 
        v-for="(item,index) in arrT" :key="index" @click="selectTime(item,index)">
        {{item}}以来
      </div>
      <div class="select-year">
        <input class="year-input" type="text" v-model="year[0]">至
        <input class="year-input" type="text" v-model="year[1]">
        <div class="year-btn" @click="selectyear()">确定</div>
      </div>
    </div>
    <div class="left-item">
      <div class="item-title">所属类别</div>
      <div class="item-content" :class="indexC === index?'searchactive':''" 
        v-for="(item,index) in arrC" :key="index" @click="selectCategorye(item,index)">
        {{item.name}}
      </div>
    </div>
    <div class="left-item">
      <div class="item-title">发布机构</div>
      <div class="item-content" :class="indexP === index?'searchactive':''" 
        v-for="(item,index) in arrP" :key="index" @click="selectPublish(item,index)">
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>
import service from '../service/demoService'
import tool from '../../static/js/public.js'
export default {
  name:'left',
  data(){
    return {
      year:[],
      searchP:{
        date:[],
        type:'',
        publish:'',
      },
      arrP:['国家级','省市级','高校级'],
      indexP:'',
      // arrC:['科学研究','人才培养','发展规划','学科建设','师资人才','综合事务'],
      arrC:[],
      indexC:'',
      arrT:['2020','2019','2018'],
      indexT:'',
    }
  },
  watch: {
  },
  methods:{
    getAllType(){
      service.getalltype().then(res =>{
        console.log(res);
        this.arrC = res;
      })
    },
    selectyear(){
      let date1 = new Date(this.year[0]).getTime();
      let date2 = new Date(this.year[1]).getTime();
      this.searchP.date = [date1,date2];
      console.log(this.searchP);
    },
    selectPublish(item,index){
      /**
       * 选择发布机构的点击事件，
       * 参数item是
       */
      if(index === this.indexP){
        this.indexP = '';
        this.searchP.publish = '';
      }else{
        this.indexP = index;
        this.searchP.publish = item;
      }
    },
    selectCategorye(item,index){
      /**
       * 选择所属类别的点击事件，
       * 参数item是类型对象
       */
      console.log(index);
      if(index === this.indexC){
        this.indexC = '';
        this.searchP.type = '';
      }else{
        this.indexC = index;
        this.searchP.type = item.id;
      }
    },
    selectTime(item,index){
     /**
       * 选择时间的点击事件，
       * 参数item是具体的年份，index是选中年份的索引
       */
      if(index === this.indexT){
        this.indexT = '';
        this.searchP.date = [];
      }else{
        this.indexT = index;
        let date = new Date(item).getTime()
        console.log(date);
        this.searchP.date = [date];
      }
      // console.log(this.searchP);
    }
  },
  created(){
    this.getAllType();
  },
  mounted(){
  },
}
</script>

<style lang="less">
@import '../../static/less/left.less';
</style>


// WEBPACK FOOTER //
// src/components/left.vue